import { useMutation, useQuery } from '@tanstack/react-query'

import { StorePersistKeys } from 'src/types'

import {
  getServiceContacts,
  addServiceContact,
  updateServiceContact,
  deleteServiceContact,
} from 'src/api/ServiceContacts'

export const useManageServiceContacts = () => {
  const { data: allServiceContacts, isLoading: isLoadingGetContacts } =
    useQuery({
      queryKey: [StorePersistKeys.SERVICE_CONTACTS],
      queryFn: getServiceContacts,
    })

  const { mutate: addServiceContacts, isLoading: isLoadingAddContact } =
    useMutation({
      mutationKey: [StorePersistKeys.SERVICE_CONTACTS],
      mutationFn: addServiceContact,
    })

  const { mutate: updateContact, isLoading: isLoadingUpdateContact } =
    useMutation({
      mutationKey: [StorePersistKeys.SERVICE_CONTACTS],
      mutationFn: updateServiceContact,
    })

  const { mutate: deleteContact, isLoading: isLoadingDeleteContact } =
    useMutation({
      mutationKey: [StorePersistKeys.SERVICE_CONTACTS],
      mutationFn: deleteServiceContact,
    })

  return {
    allServiceContacts,
    addServiceContacts,
    updateContact,
    deleteContact,
    isLoadingGetContacts,
    isLoadingAddContact,
    isLoadingUpdateContact,
    isLoadingDeleteContact,
    isLoadingGeneral:
      isLoadingGetContacts ||
      isLoadingAddContact ||
      isLoadingUpdateContact ||
      isLoadingDeleteContact,
  }
}
